import{a as o}from"./chunk-LKOWEUPS.js";import{a as r}from"./chunk-RAAYCPUM.js";function i(...n){return r(o(Math.floor),n)}export{i as a};
